
import React, { Component, Fragment } from 'react'
import { Container, Row,Col } from 'react-bootstrap'
import hall1D from '../../asset/image/hall1.jpg';
import { Link } from 'react-router-dom';
//----------------Elplore Our Event page like summer winter eid Events------------
export class AllCources extends Component {
  render() {
    return (
       <Fragment>
        <Container  className='text-center courseBackpic'>
              <h1 className='h1Tag'>Explore Our Events</h1>
            <div className='bottom'></div>
            <Row>   
                <Col lg={6} md={12} sm={12} className='p-2'>
                <Row>
                    <Col lg={6} md={6} sm={12}>
                    <img className="courseImage"src={hall1D}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Lavael 8</h5>
                    <p className='text-justify pTag'> Some quick example text to build on the card</p>
                   <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>



                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={hall1D}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Lavael 8</h5>
                    <p className='text-justify pTag'> Some quick example text to build on the card</p>
                       <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>
                    <br/>

                </Row>
               
                
                </Col>


                  <Col lg={6} md={12} sm={12}>
                     <Row>
                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={hall1D}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Lavael 8</h5>
                    <p className='text-justify pTag'> Some quick example text to build on the card</p>
                    <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                    </Col>



                    <Col lg={6} md={6} sm={12} className='p-2'>
                    <img className="courseImage"src={hall1D}></img>
                    
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                    <h5 className='text-justify h2Tag'>Lavael 8</h5>
                    <p className='text-justify pTag'> Some quick example text to build on the card</p>
                      <Link className='coursedetails' to="/CourseDetails"> View More </Link>
                      
                    </Col>

                </Row>
                  
                  </Col>
                    
            </Row>
        </Container>
     </Fragment>
    )
  }
}

export default AllCources
